// @flow
import * as React from 'react'
import Input from '../../../core/Input'

// Types
import type { Styles } from '../../../core/BaseField'
import type { Props as SelectFieldProps } from '../DesktopSelectField'

export type Props = {
  props: SelectFieldProps,
  input: { value: any },
  innerRef: Function,
  style: Styles,
}

/**
 * Component that shows select field as a editable input area for searching
 * @return {Element}
 */
const SelectInput = (props: Props) => {
  const {
    props: { renderValue, renderOption },
    input,
    innerRef,
    style,
  } = props
  const renderer = renderValue || renderOption
  const value = style.$nonEmpty ? renderer(input.value, {}) : ''

  return (
    <Input
      innerRef={innerRef}
      props={props.props}
      input={{ ...input, value }}
      style={style}
    />
  )
}

export default SelectInput
